import { Field, FormikProps } from "formik";
import ValidationError from "./ValidationError";

interface IFormTextProps<T> extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  formik: FormikProps<T>;
  id: string;
  validationError?: string;
  validationTouched?: boolean;
}

export function FormText<T>(props: IFormTextProps<T>) {
  const {
    placeholder,
    id,
    formik,
    type,
    className,
    validationError,
    validationTouched,
    ...rest
  } = props;

  return (
    <span className="position-relative">
      {validationError && validationTouched ? (
        <>
          <Field
            name={id}
            id={id}
            placeholder={placeholder}
            autoComplete="off"
            {...rest}
            className={`form-control${
              validationTouched && validationError ? " is-invalid" : ""
            }${className ? ` ${className}` : ""}`}
            type={type ? type : "text"}
          />
          <ValidationError error={validationError} show={validationTouched} />
        </>
      ) : (
        <>
          <Field
            name={id}
            id={id}
            placeholder={placeholder}
            autoComplete="off"
            {...rest}
            className={`form-control${
              formik.touched?.[id] && formik.errors?.[id] ? " is-invalid" : ""
            }${className ? ` ${className}` : ""}`}
            type={type ? type : "text"}
          />
          <ValidationError
            error={formik.errors?.[id]}
            show={formik.touched?.[id]}
          />
        </>
      )}
    </span>
  );
}
